const appConstants = {
  memberContactTypes: {
    Security: 1,
    Invoice: 2,
    Payment: 3,
    Legal: 4,
    Qualification: 5
  }
};

export default appConstants;
